<template>
  <aside
    class="alerts-rail"
    :style="{ background: 'var(--bg-elev)', border: '1px solid var(--border)' }"
    data-test="alerts-rail"
  >
    <header class="rail-head">
      <p class="rail-eyebrow">Needs attention</p>
      <h2 class="rail-title">
        Alerts
        <span v-if="alerts.length" class="rail-count">{{ alerts.length }}</span>
      </h2>
    </header>

    <div v-if="alerts.length === 0" class="rail-empty" data-test="alerts-empty">
      <p>All clear.</p>
      <p class="rail-empty-sub">No process or hygiene alerts for {{ projectKey }}.</p>
    </div>

    <ul v-else class="rail-list">
      <li v-for="alert in alerts" :key="alert.id">
        <AlertCard :alert="alert" />
      </li>
    </ul>
  </aside>
</template>

<script setup lang="ts">
import type { GovernanceAlert } from "@/lib/governanceAlerts";
import AlertCard from "./AlertCard.vue";

defineProps<{
  projectKey: string;
  alerts: GovernanceAlert[];
}>();
</script>

<style scoped>
.alerts-rail {
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: sticky;
  top: 16px;
  align-self: flex-start;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
}
.rail-head { padding-bottom: 6px; border-bottom: 1px solid var(--border, #e5e7eb); }
.rail-eyebrow {
  font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em;
  color: var(--fg-subtle, #9ca3af); margin: 0;
}
.rail-title {
  font-size: 16px; font-weight: 600; margin: 4px 0 0;
  display: flex; align-items: center; gap: 8px;
}
.rail-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 20px; height: 20px; padding: 0 6px;
  font-size: 11px; border-radius: 999px;
  background: var(--bg-card, #fff); border: 1px solid var(--border, #e5e7eb);
  color: var(--fg-muted, #6b7280); font-weight: 500;
}

.rail-empty {
  text-align: center; padding: 16px 8px;
  color: var(--fg-muted, #6b7280);
}
.rail-empty p { margin: 0; }
.rail-empty p:first-child { font-weight: 600; }
.rail-empty-sub { margin-top: 4px !important; font-size: 12px; color: var(--fg-subtle, #9ca3af); }

.rail-list { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 10px; }
</style>
